import { render, staticRenderFns } from "./PosterEditor.vue?vue&type=template&id=2925d60e"
import script from "./PosterEditor.vue?vue&type=script&lang=js"
export * from "./PosterEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports